import { render, staticRenderFns } from "./BsaPerformanceData.vue?vue&type=template&id=3d69dd0d"
import script from "./BsaPerformanceData.vue?vue&type=script&lang=js"
export * from "./BsaPerformanceData.vue?vue&type=script&lang=js"
import style0 from "./BsaPerformanceData.vue?vue&type=style&index=0&id=3d69dd0d&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d69dd0d')) {
      api.createRecord('3d69dd0d', component.options)
    } else {
      api.reload('3d69dd0d', component.options)
    }
    module.hot.accept("./BsaPerformanceData.vue?vue&type=template&id=3d69dd0d", function () {
      api.rerender('3d69dd0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/bsa/BsaPerformanceData.vue"
export default component.exports